<template>
  <section>
    <el-row>
      <el-col :span="24">
        <el-button style="float:right;">打印盘点单</el-button>
        <el-tabs v-model="tabs" type="card" @tab-click="handleClick">
          <!-- 盘点库存 -->
          <el-tab-pane label="盘点库存" name="stock">
            <el-row>
              <el-col :span="24">
                <el-table :data="checkDetail" highlight-current-row stripe border>
                  <el-table-column prop="DataID" label="序号"></el-table-column>
                  <el-table-column prop="OrderID" label="单号"></el-table-column>
                  <el-table-column prop="ReferenceID" label="来源单号"></el-table-column>
                  <el-table-column label="总数/已盘点">
                    <template slot-scope="s">
                      {{s.row.Count.Quantity}} / {{s.row.Count.Inventory}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="Count.percent" label="盘点进度"></el-table-column>
                  <el-table-column prop="Status" label="状态"></el-table-column>
                  <el-table-column label="时间">
                    <template slot-scope="s">
                      {{s.row.Date}}<br/><span style="font-size:12px;color:gray;">{{s.row.UpdateDate}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="s">
                      <el-button size="mini" @click="handleOpenSetting(s.row)">设置</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
              <el-col :span="24" class="toolbar">
                <el-form :inline="true">
                  <el-form-item label="仓库属性">
                    <el-input v-model="stockAttribute" size="small" placeholder="库存编码/包裹编码"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-select v-model="stockSelect" size="small" placeholder="仓库列表" style="width:150px">
                      <el-option v-for="item in stockList" :key="item.DataID" :value="item.DataID" :label="`${item.Code}  ${item.Name}`"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select v-model="stockArea" size="small" placeholder="库区" style="width:120px">
                      <el-option v-for="item in stockAreaList" :key="item.DataID" :value="item.DataID" :label="`${item.Code}  ${item.Name}`"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select v-model="stockArea" size="small" placeholder="所有库位" style="width:120px">
                      <el-option v-for="item in stockAreaList" :key="item.DataID" :value="item.DataID" :label="`${item.Code}  ${item.Name}`"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select v-model="owner" size="small" placeholder="货主" style="width:120px">
                      <el-option v-for="item in ownerList" :key="item.DataID" :value="item.DataID" :label="`${item.Code}  ${item.Name}`"></el-option>
                    </el-select>
                  </el-form-item>
                </el-form>
                <el-form :inline="true">
                  <el-form-item label="产品属性">
                    <el-select v-model="productRank" size="small" placeholder="产品级别" style="width:120px">
                      <el-option v-for="item in productRankList" :key="item.DataID" :value="item.DataID" :label="`${item.Code}  ${item.Name}`"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-input v-model="spu" size="small" placeholder="SPU"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-autocomplete
                      :fetch-suggestions="querySearchAsync"
                      @select="handleSelectSearch"
                      placeholder="ID / SKU / Name"
                      style="width:300px"
                      size="small">
                    </el-autocomplete>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" size="small">增加盘点库存</el-button>
                  </el-form-item>
                </el-form>
              </el-col>
              <el-col :span="24">
                <el-table :data="mainList" highlight-current-row stripe border>
                  <el-table-column prop="DataID" label="序号" width="70"></el-table-column>
                  <el-table-column prop="OrderID" label="库存"></el-table-column>
                  <el-table-column prop="" label="包含产品">
                    <template slot-scope="s">
                      <span v-for="item in s.row.Package.Product" style="display: block;">[{{item.FullSKU}}]{{item.FullName}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="Quantity" label="目标在库数量"></el-table-column>
                  <el-table-column prop="Inventory" label="已盘点数量"></el-table-column>
                  <el-table-column prop="TrueNam" label="操作同事"></el-table-column>
                  <el-table-column prop="Date" label="最后操作时间"></el-table-column>
                  <el-table-column label="操作" width="170">
                    <template slot-scope="s">
                      <el-button size="mini" @click="getCheckFlow(s.row)">查看操作流水</el-button>
                      <el-button size="mini" @click="handleDeleteCheckStock(s.row.DataID)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
              <el-col :span="24" class="toolbar">
                <el-pagination background layout="total, sizes, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="pageSize" :page-sizes="[20, 30, 50, 100]" :total="total" style="float:right;" @size-change="handleSizeChange">
                </el-pagination>
              </el-col>
            </el-row>
          </el-tab-pane>
          <!-- 流水 -->
          <el-tab-pane label="流水" name="laundry">
            <el-table :data="flowList" highlight-current-row stripe border>
              <el-table-column prop="DataID" label="序号" width="80"></el-table-column>
              <el-table-column prop="OrderID" label="单号"></el-table-column>
              <el-table-column prop="Quantity" label="数量"></el-table-column>
              <el-table-column prop="Date" label="时间" width="200"></el-table-column>
            </el-table>
          </el-tab-pane>
          <!-- 日志 -->
          <el-tab-pane label="日志" name="log">
            <el-table :data="logList" highlight-current-row stripe border>
              <el-table-column prop="DataID" label="序号" width="80"></el-table-column>
              <el-table-column prop="Name" label="操作人" width="100"></el-table-column>
              <el-table-column prop="Remark" label="备注"></el-table-column>
              <el-table-column prop="Date" label="时间" width="200"></el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
    <cm-modal-simple
      :show="modalShow"
      @close="modalClose"
      :title="'盘点单设置'"
      :width="'700px'"
      :diy-class="'diy-setting'"
      >
      <el-row>
        <el-col :span="12">
          <ul class="setting-ul">
            <li>盘点计划： {{setting.OrderID}}</li>
            <li>计划数量： {{setting.Quantity}}</li>
            <li>盘点数量： {{setting.Inventory}}</li>
            <li>状态情况： {{setting.Status}}</li>
          </ul>
        </el-col>
        <el-col :span="12">
          <div class="setting-info">
            <p>把盘点单设置为 “完成” 状态</p>
            <p>ERP会根据计划数量与盘点数量的情况，自动产生入库单和出库单，同时执行入库和出库的操作</p>
          </div>
        </el-col>
        <el-col :span="24">
          <el-button size="small" @click="setCheckState('完成')">完成盘点</el-button>
          <el-button size="small" @click="setCheckState('取消')">取消盘点</el-button>
        </el-col>
      </el-row>
    </cm-modal-simple>
    <cm-modal-simple
      :show="modalFlowShow"
      @close="modalFlowClose"
      :title="'盘点库存流水'"
      :width="'700px'"
      :diy-class="'diy-flow'"
      >
      <el-table :data="stockFlowList" highlight-current-row stripe border>
        <el-table-column prop="DataID" label="序号" width="80"></el-table-column>
        <el-table-column prop="OrderID" label="单号"></el-table-column>
        <el-table-column prop="Quantity" label="数量" width="80"></el-table-column>
        <el-table-column prop="Date" label="时间" width="200"></el-table-column>
      </el-table>
    </cm-modal-simple>
  </section>
</template>

<script>
import { WPSkuSearch, getCheckDetail, setCheckStatus, getCheckStock, getCheckStockFlow, deleteCheckStock, addCheckStock } from '../../api/api'
import util from '../../common/js/util'
import qs from 'qs'
export default {
  data () {
    return {
      tabs: 'stock',
      checkDetail: [],
      // toolbar
      // 仓库属性
      stockAttribute: '',
      // 仓库列表
      stockSelect: '',
      stockList: [],
      // 库区
      stockArea: '',
      stockAreaList: [],
      // 所有库位
      stockPlace: '',
      stockPlaceList: [],
      // 货主
      owner: '',
      ownerList: [],
      // 产品等级
      productRank: '',
      productRankList: [],
      // SPU
      spu: '',
      // 盘点库存列表
      mainList: [],
      total: 0,
      pageSize: 50,
      // 设置的模态框
      modalShow: false,
      setting: {
        OrderID: 0,
        Quantity: 0,
        Inventory: 0,
        Status: ''
      },
      // LOG 列表
      logList: [],
      // 库存流水
      stockFlowList: [],
      modalFlowShow: false
    }
  },
  methods: {
    // 切换tab事件
    handleClick (tab) {
      console.log(tab)
    },
    // 获取盘点单详情
    getCheckDetail () {
      // let postData = {}
      // getCheckDetail(postData).then(res => {})
      
      let Data = {
        Ack: true,
        Message: '操作执行完成, 耗时3.91ms',
        Head: {
          Do: 'WINQuery',
          DataID: 1,
          OrderID: '',
          ReferenceID: ''
        },
        Inventory: {
          DataID: 1,
          OrderID: 'WIN180809HNT155',
          ReferenceID: '',
          WID: 1,
          Types: '普通',
          Status: '',
          UpdateDate: '2018-08-09 16:56:55',
          Date: "2018-08-09 15:35:57",
          Count: {
            Quantity: 119,
            Inventory: 59,
            Stock: 2
          }
        },
        Flow: [
          {
            DataID: 1,
            StockID: 76706,
            OrderID: 'WPS26AAB57790002',
            WARID: 2,
            Quantity: 9,
            User: {
              DataID: 0,
              TrueName: null
            },
            Date: '2018-08-09 16:55:38',
            Package: {
              DataID: 4221,
              FreightNo: 'WPS26AAB5779',
              Product: [
                {
                  DataID: 8135,
                  Quantity: 1,
                  FullSKU: 'C0732-FSA',
                  FullName: '婚庆配饰-珍珠发梳'
                }
              ]
            }
          },
          {
            DataID: 2,
            StockID: 76706,
            OrderID: 'WPS26AAB57790002',
            WARID: 2,
            Quantity: 50,
            User: {
              DataID: 0,
              TrueName: null
            },
            Date: '2018-08-09 16:56:55',
            Package: {
              DataID: 4221,
              FreightNo: 'WPS26AAB5779',
              Product: [
                {
                  DataID: 8135,
                  Quantity: 1,
                  FullSKU: 'C0732-FSA',
                  FullName: '婚庆配饰-珍珠发梳'
                }
              ]
            }
          }
        ],
        Log: [
          {
            DataID: 8,
            UID: 0,
            Name: null,
            Remark: '扫描清点数量(76706: 50)',
            Date: '2018-08-09 16:56:55'
          },
          {
            DataID: 7,
            UID: 0,
            Name: null,
            Remark: '扫描清点数量(76706: 9)',
            Date: '2018-08-09 16:55:38'
          },
          {
            DataID: 6,
            UID: 0,
            Name: null,
            Remark: '增加待盘点库存(WPS26AAB57790002)',
            Date: '2018-08-09 16:07:55'
          },
          {
            DataID: 5,
            UID: 0,
            Name: null,
            Remark: '删除了待盘点的库存(76706 WPS26AAB57790002)',
            Date: '2018-08-09 16:06:47'
          },
          {
            DataID: 4,
            UID: 0,
            Name: null,
            Remark: '增加待盘点库存(WPS26AAB57790002)',
            Date: '2018-08-09 16:06:35'
          },
          {
            DataID: 3,
            UID: 0,
            Name: null,
            Remark: '增加待盘点库存(WPS26AAB57790002)',
            Date: '2018-08-09 16:02:16'
          },
          {
            DataID: 2,
            UID: 0,
            Name: null,
            Remark: '增加待盘点库存(WPS27AAB57750001)',
            Date: '2018-08-09 15:55:48'
          },
          {
            DataID: 1,
            UID: 0,
            Name: null,
            Remark: 'Create OrderID(WIN180809HNT155)',
            Date: '2018-08-09 15:35:57'
          }
        ]
      }

      let Flow = {
        Ack: true,
        Message: '操作执行完成, 耗时7.81ms',
        Head: {
          Do: 'WINSList',
          FID: 1
        },
        Pagination: {
          TotalNumberOfPages: 1,
          TotalNumberOfEntries: 2,
          Page: 0,
          QueryLimitNumber: 0
        },
        InventoryStock: [
          {
            DataID: 1,
            StockID: 76711,
            OrderID: 'WPS27AAB57750001',
            WARID: 2,
            Quantity: 20,
            Inventory: 0,
            TrueName: '',
            Date: '',
            Package: {
              DataID: 4225,
              FreightNo: 'WPS27AAB5775',
              Product: [
                {
                  DataID: 8024,
                  Quantity: 1,
                  FullSKU: 'T00108-Def',
                  FullName: '婴儿车太阳伞-默认款'
                }
                ]
            }
          },
          {
            DataID: 4,
            StockID: 76706,
            OrderID: 'WPS26AAB57790002',
            WARID: 2,
            Quantity: 99,
            Inventory: 0,
            TrueName: '',
            Date: '',
            Package: {
              DataID: 4221,
              FreightNo: 'WPS26AAB5779',
              Product: [
                {
                  DataID: 8135,
                  Quantity: 1,
                  FullSKU: 'C0732-FSA',
                  FullName: '婚庆配饰-珍珠发梳'
                }
              ]
            }
          }
        ]
      }

      this.checkDetail = []
      this.mainList = []
      this.flowList = []
      this.logList = []
      this.checkDetail.push(Data.Inventory)
      this.mainList = Flow.InventoryStock
      this.flowList = Data.Flow
      this.total = this.mainList.length

      this.logList = Data.Log
    },
    // 设置盘点单的模态框
    handleOpenSetting (row) {
      // this.$alert(this.$refs.box.innerHTML, '盘点单设置', {dangerouslyUseHTMLString: true})
      this.modalShow = true
      this.setting.DataID = row.DataID
      this.setting.OrderID = row.OrderID
      this.setting.Inventory = row.Count.Inventory
      this.setting.Quantity = row.Count.Quantity
      this.setting.Status = row.Types
    },
    // 设置盘点状态
    setCheckState (status) {
      let postData = {
        DataID: this.setting.DataID,
        Status: status
      }
      setCheckStatus(postData).then(res => {
        let _d = res.data
        this.$message({
          type: _d.Ack ? 'success' : 'error',
          message: _d.Message
        })
        // 当设置成功时，关闭模态框
        if (_d.Ack) { this.modalShow = false }
      })
    },
    // 查询指定盘点库存的操作流水
    getCheckFlow (row) {
      let postData = {
        FID: row.DataID,
        StockID: row.StockID
      }
      getCheckStockFlow(postData).then(res => {
        let stockFlow = {
          Ack: true,
          Message: '操作执行完成, 耗时3.91ms',
          Head: {
            Do: 'WINStockFlow',
            FID: 1,
            StockID: 76706
          },
          Flow: [
            {
              DataID: 1,
              StockID: 76706,
              OrderID: 'WPS26AAB57790002',
              WARID: 2,
              Quantity: 9,
              User: {
                DataID: 0,
                TrueName: null
              },
              Date: '2018-08-09 16:55:38',
              Package: {
                DataID: 4221,
                FreightNo: 'WPS26AAB5779',
                Product: [
                  {
                    DataID: 8135,
                    Quantity: 1,
                    FullSKU: 'C0732-FSA',
                    FullName: '婚庆配饰-珍珠发梳'
                  }
                ]
              }
            },
            {
              DataID: 2,
              StockID: 76706,
              OrderID: 'WPS26AAB57790002',
              WARID: 2,
              Quantity: 50,
              User: {
                DataID: 0,
                TrueName: null
              },
              Date: '2018-08-09 16:56:55',
              Package: {
                DataID: 4221,
                FreightNo: 'WPS26AAB5779',
                Product: [
                  {
                    DataID: 8135,
                    Quantity: 1,
                    FullSKU: 'C0732-FSA',
                    FullName: '婚庆配饰-珍珠发梳'
                  }
                ]
              }
            }
          ]
        }

        this.modalFlowShow = true

        this.stockFlowList = stockFlow.Flow
      })
    },
    // 删除盘点单里指定的库存
    handleDeleteCheckStock (id) {
      this.$confirm('确定删除？').then(() => {
        deleteCheckStock({DataID: id}).then(res => {
          let _d = res.data
          this.$message({
            type: _d.Ack ? 'success' : 'error',
            message: _d.Message
          })
        })
      }).catch(e => {})
    },
    querySearchAsync(queryString, callback) {
      // if (!queryString) {
      //   this.filters.SkuID = ''
      //   return
      // }
      let para = qs.stringify({
        KeyWord: queryString
      })
      var list = [{}]
      //从后台获取到对象数组
      WPSkuSearch(para).then(res => {
        //在这里为这个数组中每一个对象加一个value字段, 因为autocomplete只识别value字段并在下拉列中显示
        for(let i of res.data.DataList){  
            i.value  = '[' + i.Status + ']' + '[' + i.FullSKU + ']' + i.FullName //将CUSTOMER_NAME作为value
        }  
        list = res.data.DataList
        callback(list)
      }).catch(e => {
        console.log(e)
      })
    },
    //搜索栏选中后的处理函数
    handleSelectSearch(item) {  
      this.SkuID = item.DataID
      this.getList()
    },
    handleSizeChange () {},
    handleCurrentChange () {},
    // 模态框关闭事件
    modalClose () {
      this.modalShow = false
    },
    modalFlowClose () {
      this.modalFlowShow = false
    }
  },
  mounted () {
    this.getCheckDetail()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  .setting-ul {
    li {
      height: 30px;
      list-style: none;
    }
  }
</style>



// WEBPACK FOOTER //
// checkDetail.vue?499d9acc